import { render, staticRenderFns } from "./ExpandableBoxNode.vue?vue&type=template&id=bf5cb350&scoped=true&"
import script from "./ExpandableBoxNode.vue?vue&type=script&lang=js&"
export * from "./ExpandableBoxNode.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableBoxNode.vue?vue&type=style&index=0&id=bf5cb350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5cb350",
  null
  
)

export default component.exports